import { render, staticRenderFns } from "./UserRecordHolderBattlesModal.vue?vue&type=template&id=3f91211d&scoped=true&lang=pug&"
import script from "./UserRecordHolderBattlesModal.vue?vue&type=script&lang=js&"
export * from "./UserRecordHolderBattlesModal.vue?vue&type=script&lang=js&"
import style0 from "./UserRecordHolderBattlesModal.vue?vue&type=style&index=0&id=3f91211d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f91211d",
  null
  
)

export default component.exports